import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import { supabase } from "../lib/supabase";
import { Notice } from "../components/Ui";

export function LoginPage() {
  const { session, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState<{ tone: "success" | "error"; text: string } | null>(() =>
    (location.state as { passwordChanged?: boolean } | null)?.passwordChanged
      ? { tone: "success", text: "Votre mot de passe a été modifié. Vous pouvez maintenant vous reconnecter." }
      : null,
  );
  const [busy, setBusy] = useState(false);

  if (!loading && session) {
    const mustChangePassword = session.user.app_metadata?.must_change_password
      ?? session.user.user_metadata?.must_change_password;
    const target = mustChangePassword
      ? "/set-password"
      : sessionStorage.getItem("stock-return-to") || "/";
    return <Navigate to={target} replace />;
  }

  const login = async (event: React.FormEvent) => {
    event.preventDefault(); setBusy(true); setMessage(null);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setBusy(false);
    if (error) return setMessage({ tone: "error", text: "Adresse e-mail ou mot de passe incorrect." });
    const target = sessionStorage.getItem("stock-return-to") || "/";
    sessionStorage.removeItem("stock-return-to");
    navigate(target, { replace: true });
  };

  const reset = async () => {
    if (!email) return setMessage({ tone: "error", text: "Indiquez d’abord votre adresse e-mail." });
    setBusy(true);
    const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo: `${window.location.origin}/set-password` });
    setBusy(false);
    setMessage(error ? { tone: "error", text: error.message } : { tone: "success", text: "Un e-mail de réinitialisation a été envoyé." });
  };

  return <main className="login-screen"><section className="login-panel"><div className="login-brand"><span className="brand-icon">STC</span><div><strong>Stock Conférence</strong><span>Maintenance · Bruxelles</span></div></div><div className="login-copy"><p className="eyebrow">Accès sécurisé</p><h1>Connexion</h1><p>Connectez-vous avec le compte créé par votre administrateur.</p></div>{message && <Notice tone={message.tone}>{message.text}</Notice>}<form onSubmit={login} className="login-form"><label><span>Adresse e-mail</span><input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" /></label><label><span>Mot de passe</span><input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" /></label><button className="primary-button full-width" disabled={busy}>{busy ? "Connexion…" : "Se connecter"}</button><button className="text-button" type="button" onClick={reset} disabled={busy}>Mot de passe oublié ?</button></form><small className="login-help">Aucune inscription libre. Demandez un compte à un administrateur.</small></section><aside className="login-visual"><div><span>245</span><strong>références suivies</strong></div><div><span>1 030</span><strong>pièces inventoriées</strong></div><p>Scannez le QR de l’armoire pour enregistrer une sortie ou un retour.</p></aside></main>;
}
